import React from "react";
import { Globe2, Crosshair, BarChart3, Cpu } from "lucide-react";

const FEATURES = [
  { icon: Globe2, title: "Multi-sport coverage", body: "NHL, NBA and tennis (ATP, WTA and Challenger) in one account, each with its own dashboards and Official Card." },
  { icon: Crosshair, title: "Matchup intelligence", body: "Goalie weakness by position and line, opponent first-basket weakness, tip-off records, surface form and head-to-head." },
  { icon: BarChart3, title: "Player & team analytics", body: "Skater season and recent form, first-basket history, game trends, recent results and player cards." },
  { icon: Cpu, title: "Fusion model engines", body: "Each engine shows how its signals combine into a score and status, and every pick is graded afterwards in the Audit." },
];

export const Features = () => (
  <section id="features" data-testid="lp-features" className="scroll-mt-16 border-t border-white/5 bg-[#03050A] py-20">
    <div className="mx-auto max-w-7xl px-4 sm:px-6">
      <p className="font-mono text-[11px] uppercase tracking-[0.35em] text-[#22D3EE]">Platform</p>
      <h2 className="mt-3 font-condensed text-4xl font-extrabold uppercase tracking-tight text-white sm:text-5xl">Built for research, not guesswork</h2>
      <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {FEATURES.map(({ icon: Icon, title, body }, i) => (
          <div key={title} data-testid={`lp-feature-${i}`} className="rounded-2xl border border-white/10 bg-gradient-to-b from-[#0A1222] to-[#03050A] p-6 transition-[border-color] duration-200 hover:border-[#22D3EE]/40">
            <span className="inline-flex rounded-xl border border-[#22D3EE]/30 bg-[#22D3EE]/10 p-3"><Icon className="h-5 w-5 text-[#22D3EE]" /></span>
            <h3 className="mt-5 font-condensed text-2xl font-extrabold uppercase tracking-wide text-white">{title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-slate-400">{body}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
